// import { useEffect, useState } from "react";
import { Card, Container, Image } from "react-bootstrap";
import { hotels } from "../Data/hotels";
// import { fetchAllHotel } from "../Services/api";


export function Hotel() {
    // const [hotel, setHotel] = useState([]);
    // const fetchHotel = async () => {
    //     const response = await fetchAllHotel();
    //     setHotel(response.data);
    //     console.log(response.data);
    // }
    // useEffect(() => {
    //     fetchHotel();
    // }, []);

    return (
        <>
            <div>
                <Image src="https://seoimgak.mmtcdn.com/blog/sites/default/files/images/resorts-in-uttarakhand-riverview-retreat.jpg" alt="OM" style={{ width: '100%', height: '300px' }}></Image>
            </div>
            <Container className="my-5 text-center">
            <h1 style={{ borderRadius: "20px", background: '#0D6EFD', color: 'white', boxShadow: '5px 5px lightblue' , padding: '10px' }}>Hotel,Motel/Road Side Facilities/Resort/Guest House/Tourist Rest House</h1>
            </Container>
            <Container>
           

           <div className="mx-2" style={{display: "flex", flexDirection: "row", overflow: "hidden", flexWrap: "wrap", justifyContent: "center", alignItems: 'center', width: "100%", gap: "10px"}}>
               
                       {
                           hotels.map((e, index) => {
                               return (
                                   <Card key={index} style={{ width: '30rem', boxShadow: '-1px 4px 5px 0.5px rgb(0 0 0 / 10%)', borderRadius: '10px'}}>
                                   <Card.Body>
                                     <Card.Title><strong>Name:</strong> {e.name}</Card.Title>
                     
                                     <Card.Text>{e.phone}</Card.Text>
                                     <Card.Text><strong>Address:</strong> {e.address}</Card.Text>
                                     <Card.Text><strong>Email:</strong> {e.email}</Card.Text>
                              
                                   </Card.Body>
                                 </Card>
                               )
                           })
                       }
                   
           </div>
           </Container>
        </>
    );
}